export type SmallBizStoreModel = {
  chargeCardsAmount: number;
  chargingStationConfig: ChargingStationConfig;
};

export type ChargingStationConfig = {
  amount: number;
  location?: ChargePointLocation;
  type?: ChargePointType;
  smart?: boolean;
};

export enum ChargePointType {
  connect30,
  connect50,
  connect30Pro,
  connect50Pro,
}

export enum ChargePointLocation {
  wallInside30,
  wallInside50,
  wallOutside30,
  wallOutside50,
  poleOutside30,
  poleOutside50,
}
